<template>
  <section>
    <div class="form-group">
      <div class="form-control wide">
        <label
          >{{ $t('assignment.labels.formLabels.hireType')
          }}<span v-show="!isHireType" class="asterisk">*</span></label
        >
        <div class="single-line">
          <TolRadioButton
            button-label="Regular"
            label="Regular"
            name="hireType"
            :value="isHireType"
            @toggle="onIBMExtraInfoUpdate('hire_type', 'REGULAR')"
          />

          <TolRadioButton
            button-label="Supplier"
            label="Supplier"
            name="hireType"
            :value="isHireType"
            @toggle="onIBMExtraInfoUpdate('hire_type', 'SUPPLIER')"
          />

          <TolRadioButton
            button-label="Subtier (held cheques)"
            label="Subtier (held cheques)"
            name="hireType"
            :value="isHireType"
            @toggle="onIBMExtraInfoUpdate('hire_type', 'SUBTIER')"
          />
        </div>
      </div>
      <div class="form-control wide">
        <label
          >{{ $t('assignment.labels.formLabels.skillType')
          }}<span v-show="!isSkillType" class="asterisk">*</span></label
        >
        <div class="single-line">
          <TolRadioButton
            button-label="Standard"
            label="Standard"
            name="skillType"
            :value="isSkillType"
            @toggle="onIBMExtraInfoUpdate('skill_type', 'STANDARD')"
          />

          <TolRadioButton
            button-label="Hot Skill"
            label="Hot Skill"
            name="skillType"
            :value="isSkillType"
            @toggle="onIBMExtraInfoUpdate('skill_type', 'HOT_SKILL')"
          />

          <TolRadioButton
            button-label="Exception / Ultra-Hot"
            label="Exception / Ultra-Hot"
            name="skillType"
            :value="isSkillType"
            @toggle="onIBMExtraInfoUpdate('skill_type', 'EXCEPTION')"
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-control">
        <label
          >{{ $t('assignment.labels.formLabels.referralStatus')
          }}<span v-show="!isReferralStatus" class="asterisk">*</span></label
        >
        <div class="single-line">
          <TolRadioButton
            button-label="Recruited / Direct"
            label="Recruited / Direct"
            name="referralStatus"
            :value="isReferralStatus"
            @toggle="onIBMExtraInfoUpdate('referral_status', 'RECRUITED')"
          />

          <TolRadioButton
            button-label="Referral / Non-Recruited / Payrollee"
            label="Referral / Non-Recruited / Payrollee"
            name="referralStatus"
            :value="isReferralStatus"
            @toggle="onIBMExtraInfoUpdate('referral_status', 'REFERRAL')"
          />
        </div>
      </div>
      <div class="form-control wide">
        <label
          >{{ $t('assignment.labels.formLabels.servicesType')
          }}<span v-show="!isServicesType" class="asterisk">*</span></label
        >
        <div class="single-line">
          <TolRadioButton
            button-label="Technical Services"
            label="Technical Services"
            name="serviceType"
            :value="isServicesType"
            @toggle="onIBMExtraInfoServiceTypeUpdate('services_type', 'TECHNICAL')"
          />

          <TolRadioButton
            button-label="Business Services"
            label="Business Services"
            name="serviceType"
            :value="isServicesType"
            @toggle="onIBMExtraInfoUpdate('services_type', 'BUSINESS')"
          />
        </div>
      </div>
    </div>
    <hr />

    <div class="form-group">
      <div class="form-control">
        <div class="single-line">
          <label>{{ $t('assignment.labels.formLabels.csaSow') }}</label>
          <Checkbox
            size="tiny"
            :checked="ibmExtraInfo.is_csa"
            @change="onIBMExtraInfoUpdate('is_csa', !ibmExtraInfo.is_csa)"
          />
        </div>
      </div>
      <div class="form-control">
        <div class="single-line">
          <label>VOD</label>
          <Checkbox
            size="tiny"
            :checked="ibmExtraInfo.is_vod"
            @change="onIBMExtraInfoUpdate('is_vod', !ibmExtraInfo.is_vod)"
          />
        </div>
      </div>

      <div class="form-control">
        <label>CSA/RRF</label>
        <InputField
          v-model="ibmExtraInfo.csa"
          type="text"
          class="bordered"
          @input="emitIBMExtraInfo()"
        />
      </div>
    </div>

    <div class="form-group">
      <div class="form-control">
        <label>
          Family Taxonomy Title
          <span v-show="!ibmExtraInfo.family_taxonomy_title" class="asterisk">*</span>
        </label>
        <InputField
          v-model="ibmExtraInfo.family_taxonomy_title"
          type="text"
          class="bordered"
          @input="emitIBMExtraInfo()"
        />
      </div>
      <div class="form-control">
        <label>Job Role<span v-show="!ibmExtraInfo.job_role" class="asterisk">*</span></label>

        <InputField
          v-model="ibmExtraInfo.job_role"
          type="text"
          class="bordered"
          @input="emitIBMExtraInfo()"
        />
      </div>
      <div class="form-control">
        <label
          >Skill Level<span v-show="!ibmExtraInfo.skill_level_id" class="asterisk">*</span></label
        >
        <DropdownSelect
          :menu-items="displayIbmSkillLevel"
          :menu-objects="ibmSkillLevel"
          :selected-item="selectedSkillLevel(ibmExtraInfo.skill_level_id)"
          class="bordered"
          @select-item="onIBMExtraInfoSkillLevelUpdate($event)"
        />
      </div>
    </div>

    <div class="form-group">
      <div class="form-control">
        <label>Skill 1</label>

        <InputField
          v-model="ibmExtraInfo.skill1"
          type="text"
          class="bordered"
          @input="emitIBMExtraInfo()"
        />
      </div>
      <div class="form-control">
        <label>Skill 2</label>

        <InputField
          v-model="ibmExtraInfo.skill2"
          type="text"
          class="bordered"
          @input="emitIBMExtraInfo()"
        />
      </div>
      <div class="form-control">
        <label>Skill 3</label>

        <InputField
          v-model="ibmExtraInfo.skill3"
          type="text"
          class="bordered"
          @input="emitIBMExtraInfo()"
        />
      </div>
    </div>

    <div class="form-group">
      <div class="form-control">
        <label>
          Matrix Bill Rate $
          <span v-show="!ibmExtraInfo.matrix_rate" class="asterisk">*</span>
        </label>
        <InputField
          v-model="ibmExtraInfo.matrix_rate"
          type="text"
          class="bordered"
          @input="emitIBMExtraInfo()"
        />
      </div>
      <div class="form-control">
        <label>P.O. Start<span v-show="!poStartDate" class="asterisk">*</span></label>
        <FormDatePicker
          :value="poStartDate"
          type="bordered"
          @change="onIBMExtraInfoDateUpdate('po_start', $event)"
        />
      </div>
      <div class="form-control">
        <label>P.O. Stop<span v-show="!poStopDate" class="asterisk">*</span></label>
        <FormDatePicker
          v-model="poStopDate"
          type="bordered"
          @change="onIBMExtraInfoDateUpdate('po_stop', $event)"
        />
      </div>
    </div>

    <div class="form-group">
      <div class="form-control">
        <label>
          Line of Business
          <span v-show="!ibmExtraInfo.ibm_line_of_business_id" class="asterisk">*</span>
        </label>
        <DropdownSelect
          :menu-items="displayIbmLineOfBusiness"
          :menu-objects="ibmLineOfBusiness"
          :selected-item="selectedLineOfBusiness(ibmExtraInfo.ibm_line_of_business_id)"
          class="bordered"
          @select-item="onIBMExtraInfoUpdate('ibm_line_of_business_id', $event.id)"
        />
      </div>
      <div class="form-control">
        <label>Region<span v-show="!ibmExtraInfo.region" class="asterisk">*</span></label>
        <DropdownSelect
          :menu-items="region"
          :selected-item="ibmExtraInfo.region"
          class="bordered"
          @select-item="onIBMExtraInfoUpdate('region', $event)"
        />
      </div>
      <div class="form-control">
        <label>City<span v-show="!ibmExtraInfo.city" class="asterisk">*</span></label>
        <InputField
          v-model="ibmExtraInfo.city"
          type="text"
          class="bordered"
          @input="emitIBMExtraInfo()"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { dateUtils } from '@/mixins/date-utils';
import { AppGetters } from '@/app/app.keys';
import DropdownSelect from '@/app/components/DropdownSelect';
import InputField from '@/app/components/InputField';
import format from 'date-fns/format';
import FormDatePicker from '@/app/components/FormDatePicker';
import TolRadioButton from '@/app/components/TolRadioButton';
import Checkbox from '@/app/components/Checkbox';

export default {
  name: 'IBMExtraInfoDetailsForm',
  components: {
    Checkbox,
    InputField,
    FormDatePicker,
    DropdownSelect,
    TolRadioButton
  },
  mixins: [dateUtils],
  props: {
    extraInfo: {
      required: true,
      default: {}
    }
  },
  data() {
    return {
      ibmExtraInfo: {},
      region: ['West', 'Central', 'East']
    };
  },
  computed: {
    poStartDate() {
      return this.ibmExtraInfo.po_start ? this.dateFromString(this.ibmExtraInfo.po_start) : null;
    },
    poStopDate() {
      return this.ibmExtraInfo.po_stop ? this.dateFromString(this.ibmExtraInfo.po_stop) : null;
    },
    displayIbmLineOfBusiness() {
      return this.$store.getters[AppGetters.IbmLineOfBusiness].map(lob => lob.name);
    },
    ibmLineOfBusiness() {
      return this.$store.getters[AppGetters.IbmLineOfBusiness];
    },
    displayIbmSkillLevel() {
      if (this.ibmExtraInfo.services_type && this.ibmExtraInfo.services_type === 'TECHNICAL') {
        let value = this.$store.getters[AppGetters.IbmSkillLevel]
          .filter(skillLevel => {
            if (skillLevel.services_type === 'TECHNICAL') {
              return skillLevel.name;
            }
          })
          .map(skillLevel => skillLevel.name);
        return value;
      } else if (
        this.ibmExtraInfo.services_type &&
        this.ibmExtraInfo.services_type === 'BUSINESS'
      ) {
        let value = this.$store.getters[AppGetters.IbmSkillLevel]
          .filter(skillLevel => {
            if (skillLevel.services_type === 'BUSINESS') {
              return skillLevel.name;
            }
          })
          .map(skillLevel => skillLevel.name);
        return value;
      } else {
        return [];
      }
    },
    ibmSkillLevel() {
      if (this.ibmExtraInfo.services_type) {
        if (this.ibmExtraInfo.services_type && this.ibmExtraInfo.services_type === 'TECHNICAL') {
          return this.$store.getters[AppGetters.IbmSkillLevel].filter(
            skillLevel => skillLevel.services_type === 'TECHNICAL'
          );
        } else if (
          this.ibmExtraInfo.services_type &&
          this.ibmExtraInfo.services_type === 'BUSINESS'
        ) {
          return this.$store.getters[AppGetters.IbmSkillLevel].filter(
            skillLevel => skillLevel.services_type === 'BUSINESS'
          );
        }
      } else {
        return [];
      }
      return [];
    },
    isSkillType() {
      let skillType = {
        STANDARD: 'Standard',
        HOT_SKILL: 'Hot Skill',
        EXCEPTION: 'Exception / Ultra-Hot'
      };
      return this.ibmExtraInfo.skill_type ? skillType[this.ibmExtraInfo.skill_type] : '';
    },
    isReferralStatus() {
      let referralStatus = {
        RECRUITED: 'Recruited / Direct',
        REFERRAL: 'Referral / Non-Recruited / Payrollee'
      };

      return this.ibmExtraInfo.referral_status
        ? referralStatus[this.ibmExtraInfo.referral_status]
        : '';
    },
    isHireType() {
      let hireType = {
        REGULAR: 'Regular',
        SUPPLIER: 'Supplier',
        SUBTIER: 'Subtier (held cheques)'
      };

      return this.ibmExtraInfo.hire_type ? hireType[this.ibmExtraInfo.hire_type] : '';
    },
    isServicesType() {
      let servicesType = {
        BUSINESS: 'Business Services',
        TECHNICAL: 'Technical Services'
      };

      return this.ibmExtraInfo.services_type ? servicesType[this.ibmExtraInfo.services_type] : '';
    }
  },
  watch: {
    extraInfo: function() {
      this.ibmExtraInfo = { ...this.extraInfo };
    }
  },
  mounted() {
    this.ibmExtraInfo = { ...this.extraInfo };
  },
  methods: {
    selectedLineOfBusiness(id) {
      let [lineOfBusiness] = this.$store.getters[AppGetters.IbmLineOfBusiness].filter(
        lob => lob.id == id
      );
      return lineOfBusiness ? lineOfBusiness.name : null;
    },
    selectedSkillLevel(id) {
      if (this.ibmExtraInfo.services_type && id) {
        let [skillLevel] = this.$store.getters[AppGetters.IbmSkillLevel].filter(
          skill => skill.id == id
        );
        return skillLevel ? skillLevel.name : null;
      }
    },
    emitIBMExtraInfo() {
      this.$emit('IBMExtraInfoUpdate', this.ibmExtraInfo);
    },
    onIBMExtraInfoUpdate(fieldName, value) {
      this.ibmExtraInfo[fieldName] = value;
      this.ibmExtraInfo = { ...this.ibmExtraInfo };
      this.emitIBMExtraInfo();
    },
    onIBMExtraInfoServiceTypeUpdate(fieldName, value) {
      this.ibmExtraInfo[fieldName] = value;
      this.ibmExtraInfo['skill_level_id'] = null;
      this.ibmExtraInfo = { ...this.ibmExtraInfo };
      this.emitIBMExtraInfo();
    },
    onIBMExtraInfoDateUpdate(fieldName, value) {
      this.ibmExtraInfo[fieldName] = this.formatDate(value);
      this.ibmExtraInfo = { ...this.ibmExtraInfo };
      this.emitIBMExtraInfo();
    },
    onIBMExtraInfoSkillLevelUpdate(value) {
      this.ibmExtraInfo['skill_level_id'] = value.id;
      this.ibmExtraInfo = { ...this.ibmExtraInfo };
      this.emitIBMExtraInfo();
    },
    formatDate(d) {
      return d ? format(d, 'YYYY-MM-DD') : null;
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.asterisk {
  color: red;
}

.form-group {
  display: flex;
  justify-content: space-between;
}

.form-control {
  padding: 10px 0;
  width: 350px;

  &.wide {
    width: 500px;
  }
  > label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
  }
  input,
  textarea,
  select {
    display: block;
    width: 100%;
    padding: 5px 0;
  }
  .spacer {
    padding-left: 10px;
  }
  .binary-controls {
    padding: 10px 0;
  }
  .error,
  .error-div {
    color: $red;
    background-color: $primary-error;
  }
  .error-div {
    padding: 8px;
    &:hover {
      cursor: pointer;
    }
    svg {
      margin-right: 15px;
    }
  }

  .end-label {
    display: inline-block;
    padding: 8px 5px;
    background-color: $light-grey-2;
    color: $mid-grey-1;
    margin-left: 5px;
  }

  .tol-list ul li .remove {
    width: 30px;
    height: 30px;

    font-size: 1.2em;
    color: $row-border;
    text-align: center;
    float: right;
    &:hover {
      background-color: $row-border;
      border-radius: 100%;
      color: $white;
    }
  }

  .single-line {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    label {
      margin-right: 15px;
    }
  }
}

.form-input {
  border-bottom: 1px solid $blue;
  font-size: 1em;
  height: inherit;
  &:focus {
    outline: none;
  }
  &.error {
    border-bottom: 1px solid $red;
  }

  &.small {
    width: auto;
    display: inline-flex;
    margin-right: 15px;
  }

  &.form-number-input {
    width: 50px;
    border: 1px solid $mid-blue;
    display: inline-flex;
    padding: 5px 0;
    &.wide {
      width: 100px;
    }
  }
}
</style>
